import { render, staticRenderFns } from "./designer.html?vue&type=template&id=04ba27c8&scoped=true&"
import script from "./designer.js?vue&type=script&lang=js&"
export * from "./designer.js?vue&type=script&lang=js&"
import style0 from "./designer.scss?vue&type=style&index=0&id=04ba27c8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ba27c8",
  null
  
)

export default component.exports